import React from 'react';
import ActionButton from '../../../action-button';
const PaginationButton = ({
  label = '',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'IconGlyph'.
  iconGlyph = null,
  selected = false,
  disabled = false,
  onClick,
}) => (
  <ActionButton
    size="small"
    label={label}
    iconGlyph={iconGlyph}
    selected={selected}
    disabled={disabled}
    onClick={onClick}
  />
);

export default PaginationButton;
